import React, {Component} from 'react'

class ShortUserInfo extends Component {

    render() {
        let {user, lang} = this.props;

        let countryDisplayed = user['country_'+lang._code] ? user['country_'+lang._code] : '';
        let regionDisplayed = user['region_'+lang._code] ? user['region_'+lang._code] : '';

        let genderDisplayed = () => {
            switch (user.gender) {
                case 1: return lang.info_male; break;
                case 2: return lang.info_female; break;
                case 3: return lang.info_couple; break;
                case 4: return lang.info_trans; break;
                default: return '';
            }
        };

        let putComma = (checkVar) => checkVar !== '' ? ',' : '';

        return (`
            ${(user.age && lang.info_years(user)) + putComma(genderDisplayed())} 
            ${genderDisplayed() + putComma(countryDisplayed)} 
            ${countryDisplayed + putComma(regionDisplayed)}
            ${regionDisplayed}
        `)
    }
}

export default ShortUserInfo;


// WEBPACK FOOTER //
// ./src/components/bobtv-neo/UserInfoTooltip/ShortUserInfo.js